
import { Injectable, Output ,EventEmitter } from "@angular/core";
import { MatDialog } from "@angular/material";
import { CommonAlertDialogComponent } from "../common-alert-dialog/common-alert-dialog.component";
import { CommonConfirmDialogComponent } from '../common-confirm-dialog/common-confirm-dialog.component';
import { CommonExpirationTimeoutConfirmDialogComponent } from "../common-expiration-timeout-confirm-dialog/common-expiration-timeout-confirm-dialog.component";
import { ConfirmDialogComponent } from "../confirm-dialog/confirm-dialog.component";

@Injectable({
  providedIn: "root",
})
export class DialogService {
  constructor(private dialog: MatDialog) {
    
  }
  message: string;
  title: string;

  // opens confirm dialog box
  openConfirmDialog(title: string, messsag: string) {
    return this.dialog.open(CommonConfirmDialogComponent, {
      width: "400px",
      height: "300px",
      panelClass: "commonconfirm-dialog-container",
      disableClose: true,
      position: { top: "19%" },
      data: {
        title: title,
        message: messsag,
      },
    });
  }

  // display alert popup
  openAlertDialogDialog(
    title: string,
    html: string,
    w: string = "400px",
    h: string = "200px"
  ) {
    return this.dialog.open(CommonAlertDialogComponent, {
      panelClass: "commonconfirm-dialog-container",
      disableClose: true,
      position: { top: "19%" },
      data: {
        title: title,
        message: html,
        width: w,
        height: h,
      },
    });
  }

  // opens ExpiratiomTimeout dialog box
  openExpirationTimeConfirmDialog(title: string, messsag: any, expirationTimeInSeconds: number) {
    return this.dialog.open(CommonExpirationTimeoutConfirmDialogComponent, {
      width: "570px",
      height: "300px",
      panelClass: "commonconfirm-dialog-container",
      disableClose: true,
      position: { top: "19%" },
      data: {
        title: title,
        message: messsag,
        expirationTimeInSeconds
      },
      backdropClass:'backdropBackground'
    });
  }
  openNoteDialog(note: string): void {
    this.dialog.open(ConfirmDialogComponent, {
      width: "600px",
      panelClass: "commonconfirm-dialog-container",
      disableClose: true,
      data: {
        title: 'Note',
        message: note
      }
    });
  }

}
